<template>
    <div>
        <div class="row justify-between mt-5 main_grid">
             
            <div
                class="offset-md-3 col-md-6 rounded shadow col-sm"
                v-if="!checkinValidate"
            >
                <div class="my-5 p-4">
                    <h1 class="pt-4 text-black">
                      Welcome to {{ outlet.name }}
                    </h1>
                    <div class="mt-4">
                        <div class="form-group">
                            <input
                                class="form-control form-control-lg border border-secondary bg-light"
                                type="text"
                                placeholder="Enter your code"
                                v-model="code"
                            />
                         <h5
                                class="text-secondary py-2"
                                v-if="codeError != ''"
                            >
                                {{ codeError }}
                            </h5>
                             <!-- <h5
                                class="text-success py-2"
                                v-if="codeSuccess != ''"
                            >
                                {{ codeSuccess }}
                            </h5> -->
                            <div class="col-md-4 col-sm-12 px-0">
                                <button
                                    type="button"
                                    class="btn btn-lg btn-block btn-danger mt-3"
                                    @click="validateCheckin"
                                >
                                    Submit
                                </button>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="d-flex justify-content-end">
                    <h5 class="pt-1 text-black mr-2">{{ outlet.name }}!</h5>
                    <button type="button" class="btn btn-info " @click="logoutCheckIn">Logout</button>
                </div>
                <h1 class="pt-4 text-black">Hello {{ user.name }}!</h1>
                <h4>Total Visits: {{user.consume_point}}</h4>
                <div class="row mb-5">
                        <div
                            class="col-md-6 col-lg-3 col-sm-12 coupon_box"
                            v-for="coupon in expectedCoupons"
                            :key="coupon.id"
                        >
                            <span class="text-decoration-none text-dark">
                                <div class=" px-3 text-center py-3 rounded shadow-sm bg-white mt-4">
                                    <img
                                        src="/assets/img/coupon.png"
                                        class="text-center py-3"
                                        width="100"
                                    />
                                    <h5 class="font-weight-bold" style="width:15rem">
                                        {{ coupon.title }}
                                    </h5>
                                    <hr />
                                    <a class="text-primary mb-0 font-weight-bolder" style="cursor: pointer;" @click="useCoupon(coupon, 'expected')">
                                        Use the Coupon
                                    </a>
                                    <div class="d-flex justify-content-center mt-2">
                                        <div class="date-time-section">
                                            <p class="m-0 text-black font-weight-bold">
                                                <i class="far fa-calendar-alt"></i> {{ formatDate(coupon.created_at) }}
                                            </p>
                                            <p class="m-0 text-black font-weight-bold">
                                                <i class="far fa-clock"></i> {{ formatTime(coupon.created_at) }}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </span>
                        </div>
                    </div>

                <div class="row mb-5">
                    <div
                        class="col-md-6 col-lg-3 col-sm-12 coupon_box"
                        v-for="coupon in coupons"
                        :key="coupon.id"
                    >
                        <span class="text-decoration-none text-dark">
                            <div class="px-3 text-center py-3 rounded shadow-sm bg-white mt-4">
                                <img
                                    src="/assets/img/coupon.png"
                                    class="text-center py-3"
                                    width="100"
                                />
                                <h5 class="font-weight-bold" style="width:15rem">
                                    {{ coupon.title }}
                                </h5>
                                <!-- <h4 class="font-weight-bolder">100/-</h4> -->
                                <hr />
                                <p v-if="coupon.consume === 'expired' && coupon.used != '1'" class="text-danger mb-0 font-weight-bolder">
                                    Expired
                                </p>
                                 <p v-else-if="coupon.used == 1" class="text-success mb-0 font-weight-bolder">
                                    Consumed
                                </p>
                                <a v-else class="text-primary mb-0 font-weight-bolder"  style="cursor: pointer;"  @click="useCoupon(coupon,'normal')">
                                    Use the Coupon
                                </a>
                                 <div class="d-flex justify-content-center mt-2">
                                    <div class="date-time-section">
                                        <p class="m-0 text-black font-weight-bold">
                                        <i class="far fa-calendar-alt"></i> {{ formatDate(coupon.created_at) }}
                                        </p>
                                        <p class="m-0 text-black font-weight-bold">
                                        <i class="far fa-clock"></i> {{ formatTime(coupon.created_at) }}
                                        </p>
                                    </div>
                                    </div>
                            </div>
                        </span>
                    </div>
                </div>
                <div class="mb-5 pb-5 text-center">
                    <button
                        type="button"
                        class="btn btn-info mt-3"
                        @click="loadMoreCoupons"
                        v-if="nextURL != '' && nextURL != null"
                    >
                        Load More
                    </button>
                </div>
            </div>
            <div
                class="offset-md-4 col-md-4 rounded shadow col-sm qr_grid_box"
                v-if="!checkinValidate"
            >
                <div class="my-5 p-4 qr_code_box">
                    <h1 class="pt-4 text-black text-center">Qr Code</h1>
                    <div class="mt-4 ml-3 qr_image">
                        <qr-code :text="JSON.stringify(qr_value)"></qr-code>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>

.qr_image img {
    object-fit: contain;
    max-width: 100%;
    align-self: center !important;
}
.qr_code_box {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.coupon_box {
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;
}

.coupon-card {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    min-height: 350px; /* Ensures consistent card height */
    max-width: 100%;
    padding: 1rem;
}

.coupon-title {
    word-wrap: break-word;
    width: 100%;
    white-space: normal;
}

.date-time-section p {
    margin-bottom: 0.25rem;
}

@media (min-width: 768px) {
    .offset-md-3 {
        margin-left: auto;
        margin-right: auto;
    }
    .offset-md-4 {
        margin-left: 9%;
    }
    .qr_grid_box {
        min-width: 47%;
        margin-left: 16px;
    }
    .coupon_box {
        flex: 1;
        max-width: 100%;
    }
}
@media (max-width: 767px) {
    .qr_grid_box {
        margin-bottom: 1.5rem !important;
        margin-top: 1.5rem !important;
    }
    .main_grid {
        padding: 0.5rem !important;
        flex-direction: column;
    }
}
@media screen and (min-width: 1023px) and (max-width: 1025px) {
    .main_grid {
        margin-bottom: 100px;
    }
}
</style>
<script>
import VueQRCodeComponent from "vue-qrcode-component";
import Vue from "vue";
Vue.component("qr-code", VueQRCodeComponent);
export default {
    name: "ValidateCheckin",
    props: ["outlet"],
    data() {
        return {
            coupons: [],
            expectedCoupons:[],
            code: "",
            codeError: "",
            codeSuccess: "",
            checkinValidate: false,
            nextURL: "",
            user: {},
            qr_value: {
                outlet_id: this.outlet.id,
                latitude: this.outlet.latitude,
                longitude: this.outlet.longitude
            },
              currentUrl: window.location.href,
          isFlagSet: false,
        };
    },
    components: {
        VueQRCodeComponent
    },
    created() {
        // window.Echo.channel("scanner").listen("checkScan", (e) => {
        //     this.scanQr(e.id);
        // });
        
        window.Echo.private(`scanner-${this.outlet.user_id}`).listen("checkScan", (e) => {
            this.scanQr(e.id);
        });
    },
    mounted() {
    //this.removeUrl();
    },
    methods: {
        scanQr(id) {
            let self = this;
            this.codeError = "";
            self.coupons = [];
            self.code= id;
            axios
                .post(baseURL + "/api/validate/scan", {
                    outlet_id: self.outlet.id,
                    checkin_id:id   
                })
                .then(function(response) {
                    if (response.data.status == "200") {
                        const logoutElements = document.getElementsByClassName('logout');
                        if (logoutElements.length > 0) {
                            logoutElements[0].style.display = 'none';
                        } else {
                            console.error('Logout element not found');
                        }
                        self.checkinValidate = true;
                        self.user = response.data.data.user;
                        axios
                        .get(baseURL + "/api/getCouponByDriverId", {
                            params: {
                                id: self.user.id
                            }
                        })
                        .then(function(response) {
                            if (response.data.status == "200") {
                                    response.data.data.forEach(function(el) {
                                    self.expectedCoupons.push(el);
                                });
                            }
                        })

                        response.data.data.coupon.data.forEach(function(el) {
                            self.coupons.push(el);
                        });
                        self.nextURL = response.data.data.coupon.next_page_url;
                    } else {
                        self.codeError = response.data.data;
                    }
                })
                .catch(function(error) {
                    self.codeError = "Not verified";
                });
        },
        formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB'); // DD/MM/YYYY format
    },
    formatTime(dateString) {
      const date = new Date(dateString);
      return date.toLocaleTimeString(); // HH:MM:SS AM/PM format
    },
        validateCheckin() {
            let self = this;
            this.codeError = "";
            if (this.code == "") {
                this.codeError = "Please enter verification code.";
            } else {
                self.coupons = [];
                //hit API for validatio
                axios
                    .post(baseURL + "/api/validate/checkin", {
                        outlet_id: self.outlet.id,
                        checkin_id: self.code
                    })
                    .then(function(response) {
                        if (response.data.status == "200") {
                            self.checkinValidate = true;
                            self.user = response.data.data.user;
                            response.data.data.coupon.data.forEach(function(
                                el
                            ) {
                                self.coupons.push(el);
                            });
                           // self.nextURL =
                            //    response.data.data.coupon.next_page_url;
                        } else {
                            self.codeError = response.data.data;
                        }
                    })
                    .catch(function(error) {
                        self.codeError = "Not verified";
                    });
            }
        },
        loadMoreCoupons() {
            let self = this;
            axios
                .post(self.nextURL, {
                    outlet_id: self.outlet.id,
                    checkin_id: self.code
                })
                .then(function(response) {
                    if (response.data.status == "200") {
                        self.checkinValidate = true;
                        response.data.data.coupon.data.forEach(function(el) {
                            self.coupons.push(el);
                        });
                        self.nextURL = response.data.data.coupon.next_page_url;
                    }
                });
        },
        consumeCouponExpected(couponId,driverId,point){
              axios
                    .post(baseURL + "/api/consumeCoupon", {
                        coupon_id: couponId,
                        driverId:driverId,
                        visit_count:point
                    })
                    .then(function(response) {
                        if (response.data.status == "200") {
                            self.codeSuccess = "Coupon consume successfuly.";
                        } else {    
                           self.codeError = "Not Consume Coupon";
                        }
                    })
                    .catch(function(error) {
                        self.codeError = "Not verified";
                    });
        },
        consumeCoupon(couponId,driverId){
              axios
                    .post(baseURL + "/api/consumeCoupon", {
                        coupon_id: couponId,
                        driverId:driverId,
                    })
                    .then(function(response) {
                        if (response.data.status == "200") {
                            self.codeSuccess = "Coupon consume successfuly.";
                        } else {    
                           self.codeError = "Not Consume Coupon";
                        }
                    })
                    .catch(function(error) {
                        self.codeError = "Not verified";
                    });
        },
        logoutCheckIn(){
            this.checkinValidate =false;
            this.code = '';
        },
        useCoupon(coupon,type) {
            let self = this;
            if (coupon.used != "1") {
                if(type == 'normal'){
                    this.consumeCoupon(coupon.id,self.user.id);
                }else{
                    this.consumeCouponExpected(coupon.id,self.user.id,coupon.visit_count);
                }
                axios.get("/api/status").then(function(response) {
                    if (response.data.status == "200") {
                        axios
                            .post("http://localhost/everycom/", {
                                couponCode: coupon.alias,
                                outletName: self.outlet.name,
                                outletAddress: self.outlet.address,
                                driverName: self.user.name,
                                driverPhone: self.user.phone_no,
                                companyName: self.user.company,
                                couponType: coupon.type,
                                couponAmount: coupon.amount
                            })
                            .then(response => {
                            
                                if (response.status == "200") {
                                    axios
                                        .post("/api/use/coupon", {
                                            outlet_id: self.outlet.id,
                                            coupon_alias: coupon.alias
                                        })
                                        .then(function(response) {
                                            self.validateCheckin();

                                        });
                                }
                            });
                    }
                });
            }
        }
    }
};
</script>
